import { Platform } from 'react-native';

type ForceInitFunction = (smartuserId: string) => Promise<void>;

class RevenueCatInitializer {
  private forceInitFunction: ForceInitFunction | null = null;

  setForceInitFunction(fn: ForceInitFunction) {
    console.log('🛒 [Initializer] Force init function registered');
    this.forceInitFunction = fn;
  }

  async forceInitialize(smartuserId: string): Promise<void> {
    if (Platform.OS === 'web') {
      console.log('🛒 [Initializer] Skipping on web platform');
      return;
    }

    if (!this.forceInitFunction) {
      console.warn('🛒 [Initializer] Force init function not registered, skipping explicit initialization');
      return;
    }

    console.log('🛒 [Initializer] Calling force init function for user:', smartuserId);
    await this.forceInitFunction(smartuserId);
  }

  isAvailable(): boolean {
    return this.forceInitFunction !== null;
  }

  clear() {
    console.log('🛒 [Initializer] Clearing force init function');
    this.forceInitFunction = null;
  }
}

export const revenueCatInitializer = new RevenueCatInitializer();
